import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import { useVerification } from '../contexts/VerificationContext';

interface BlurredCardProps {
  children: React.ReactNode;
  showLabel?: boolean;
}

const BlurredCard = ({ children, showLabel = true }: BlurredCardProps) => {
  const { isVerified } = useVerification();

  if (isVerified) {
    return <>{children}</>;
  }

  return (
    <div className="relative h-full flex flex-col" inert>
      {showLabel && (
        <div className="absolute inset-0 z-10 flex items-center justify-center">
          <div className="bg-white bg-opacity-70 px-4 py-2 rounded-lg shadow-md">
            <div className="flex items-center">
              <LockClosedIcon className="h-5 w-5 text-red-500 mr-2" />
              <span className="font-medium text-gray-800">Confirm patient information to view</span>
            </div>
          </div>
        </div>
      )}
      <div className="blur-sm pointer-events-none h-full flex-grow">
        {children}
      </div>
    </div>
  );
};

export default BlurredCard;
